import React from "react";
import "../../../../../styles/Pages/Financial/CashOutFlow/Charity/ReusalbeTable.style.css";

const ReusableTable = ({
  title,
  countLabel,
  columns,
  data,
  renderedElement,
  gridColumnStyle = "2fr 1fr 1fr",
}) => {
  return (
    <div style={{ width: "450px" }} className="ReusableTable-container">
      <div className="ReusableTable-header">
        <h2 style={{ fontWeight: "400" }}>{title}</h2>
        <span className="ReusableTable-count">{countLabel}</span>
      </div>

      <div
        style={{ gridTemplateColumns: gridColumnStyle }}
        className="ReusableTable-head-row"
      >
        {columns.map((col, idx) => (
          <div style={{ textAlign: idx === 0 ? "left" : "center" }} key={idx}>
            {col.header}
          </div>
        ))}
      </div>
      <div className="ReusableTable-body">
        {data.map((row, rowIndex) => (
          <div
            style={{ gridTemplateColumns: gridColumnStyle }}
            className="ReusableTable-row"
            key={rowIndex}
          >
            {columns.map((col, colIndex) => (
              <div
                style={{ textAlign: colIndex === 0 ? "left" : "center" }}
                key={colIndex}
              >
                {col.render
                  ? col.render(row[col.accessor], row)
                  : row[col.accessor]}
              </div>
            ))}
          </div>
        ))}
      </div>
      {renderedElement}
    </div>
  );
};

export default ReusableTable;
